































































































































import Vue from "vue";
import Component from "vue-class-component";
import QNotify from "@/common/qNotify";
import qNotify from "@/common/qNotify";
import QErrors from "@/common/qErrors.vue";
import { IrManagerService } from "@/common/api";
import { IRCreateIRResponseApiRespoonse } from "@/common/api/models/IRCreateIRResponseApiRespoonse.ts";
import { IREditIRResponseApiRespoonse } from "@/common/api/models/IREditIRResponseApiRespoonse.ts";
import { IRDeleteIRResponseApiRespoonse } from "@/common/api/models/IRDeleteIRResponseApiRespoonse";
import { compareWithKeys } from "@/common/utils";
import QSelect2 from "@/common/qSelect2.vue";
import uploadFile from "@/components/common/uploadFile.vue";
import { CATEGORIES } from "@/model/otherIr";

@Component({
  name: "OtherIrAdd",
  components: {
    QSelect2,
    QErrors,
    uploadFile,
  },
})
export default class OtherIrAdd extends Vue {
  public isShow = false;
  public isEdit = false;
  public errors: any = {};
  public errorStyle = {
    maxWidth: "100%",
  };
  public otherIr: any = {};

  public categories = CATEGORIES;

  public initForm: any = {};

  public form: any = {};

  public files = [];
  public fileUploadStatus = "";

  get isFileUploading() {
    return this.fileUploadStatus === "uploading";
  }

  public uploadOptions = {
    maxFiles: 1,
    maxFilesize: 2, // 2mb
    acceptedFiles: ".pdf",
  };

  public clearForm() {
    this.initForm = {
      category: "公告",
      title: "",
      fileId: "",
    };
    this.form = { ...this.initForm };
    this.errors = {};
    this.otherIr = {};
    this.isEdit = false;
    this.files = [];
    this.fileUploadStatus = "";
    (this.$refs.myVueDropzone as uploadFile).removeAllFile();
    this.$set(this, "errors", {});
  }

  public show(otherIr = null) {
    this.clearForm();
    if (otherIr) {
      this.isEdit = true;
      this.otherIr = otherIr;
      this.form = {
        category: otherIr.category,
        title: otherIr.title,
        fileId: otherIr.file.id,
      };
      this.files.push(otherIr.file);
      this.initForm = { ...this.form };
    }
    this.isShow = true;
    console.log("isShow:", this.isShow);
  }

  async addOtherIr() {
    this.errors = {};
    let result;
    try {
      result = await IrManagerService.otherIrCreate(this.form);
    } catch (error) {
      result = error;
    }

    if (result.status == IRCreateIRResponseApiRespoonse.status.SUCCESS) {
      qNotify.success({
        text: this.$t("common.message.created"),
      });
      this.isShow = false;
      this.$emit("closeAdded");
    } else if (result.status == "400") {
      this.errors = result.body.errors;
    } else {
      QNotify.error({
        text: result.body.message,
      });
    }
  }

  async editOtherIr() {
    this.errors = {};
    let result;
    try {
      result = await IrManagerService.otherIrEdit({
        ...this.form,
        ...{ id: this.otherIr.id },
      });
    } catch (error) {
      result = error;
    }

    if (result.status == IREditIRResponseApiRespoonse.status.SUCCESS) {
      qNotify.success({
        text: this.$t("common.message.updated"),
      });
      this.$emit("closeEdited", result.data.otherIr);
      this.isShow = false;
    } else if (result.status == "400") {
      this.errors = result.body.errors;
    } else {
      QNotify.error({
        text: result.body.message,
      });
    }
  }

  public confirmDeleteOtherIr() {
    this.errors = {};
    this.$modal.showDelete({
      text: this.$t("common.modal.delete_content"),
      onConfirm: () => {
        this.deleteOtherIr();
      },
      onClose: () => {
        console.log("onClose");
      },
    });
  }

  async deleteOtherIr() {
    let result;
    try {
      result = await IrManagerService.otherIrDelete({
        id: this.otherIr.id,
      });
    } catch (error) {
      result = error;
    }

    if (result.status == IRDeleteIRResponseApiRespoonse.status.SUCCESS) {
      qNotify.success({
        text: this.$t("common.message.deleted"),
      });
      this.isShow = false;
      this.$emit("closeEdited");
    } else if (result.status == "400") {
      this.errors = result.body.errors;
    } else {
      QNotify.error({
        text: result.body.message,
      });
    }
  }
  public cancel() {
    if (this.isChanged()) {
      this.$modal.showCancel({
        text: `${this.$t("common.modal.cancel_content")}`,
        confirmText: `${this.$t("common.buttons.yes")}`,
        cancelText: `${this.$t("common.buttons.no")}`,
        onConfirm: () => {
          this.isShow = false;
        },
      });
    } else {
      this.isShow = false;
    }
  }

  public isChanged() {
    return !compareWithKeys(this.form, this.initForm, [
      "category",
      "title",
      "fileId",
    ]);
  }

  public changeFile(files) {
    this.errors.fileId = [];
    if (files.length > 0) {
      this.files = [files[0]];
      this.form.fileId = this.files[0].id;
    } else {
      this.files = [];
      this.form.fileId = "";
    }
  }

  public changeInput(key) {
    this.errors = { ...this.errors, ...{ [key]: [] } };
  }

  public pushError(message) {
    this.errors = {
      ...this.errors,
      ...{ fileId: [message] },
    };
  }
}
